import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';
import store from 'store';

import vuex from '..';
import Utils from '../../modules/Utils';
import router from '../../router';
import API, { Types } from '../../modules/API';
import Vue from 'vue';
import moment from 'moment-timezone';
import MQTT from '@/modules/MQTT';
import { isAnyAllowedRoles } from '@/modules/constants';
import { VersionService } from '@/services/VersionService';

@Module({ namespaced: true })
export default class User extends VuexModule {
  error = '';
  isAuth = false;
  role = '';
  verified = '';
  username = '';
  user_id = '';
  isManager = false;
  isLoading = true;
  idleIntervalActive = false;
  idleInterval: any = null;
  cabinet = {};
  project = store.get('project');
  // firstnotificationTime = 0;
  // notifications = [];
  mqtt = MQTT.instance;
  properties = [];
  user_profile = null;
  roles = [];
  permissions_allowed = null;

  @Action async init(data = store.get('user')) {
    vuex.commit('Projects/setProjectAlerts', []);
    vuex.commit('Projects/setProjectEvents', []);

    const isAuthPassed = data && data.jwt_token;
    if (!isAuthPassed) {
      vuex.commit('User/setIsLoading', false);
      return;
    }
    if (window.location.pathname === '/sign') {
      localStorage.setItem('last_time_seen', moment().utcOffset(0).valueOf().toString());
    }
    vuex.commit('User/setUserData', data);
    vuex.commit('User/listenToEvents');
    vuex.commit('User/generalDataUpdateEveryMinute');
    vuex.commit('User/setLogoutInterval');
  }

  @Action
  async fetchProjectsData() {
    vuex.dispatch('Global/loadDeviceClasses');
    await vuex.dispatch('Projects/load');

    // Load metadata for existing project from localStorage
    const existing_project = store.get('project');
    if (existing_project && existing_project.id) {
      if (existing_project.id === 'allProjects') {
        // console.log('[fetchProjectsData] Loading metadata for all projects');
        if (existing_project.projects && existing_project.projects.length > 0) {
          await vuex.dispatch('Projects/loadAllProjectsMetadata', existing_project.projects);
        }
      } else {
        // console.log('[fetchProjectsData] Loading metadata for existing project:', existing_project.id);
        await vuex.dispatch('Projects/loadSelectedProjectMetadata', {
          company_id: existing_project.company,
          project_id: existing_project.id
        });
      }
    }
    // vuex.dispatch('User/setUserNotificationTime');
  }

  @Action
  async fetchUserProperties() {
    const response = await API.get(Types.PROPS, '');
    if (response && response.results) vuex.commit('User/setUserProperties', response.results);
  }

  @Action
  async fetchUserProfile() {
    const user = store.get('user');
    const response = await API.get(Types.COMPANIES, `${user.company}/users/profile/`);
    if (response) vuex.commit('User/setUserProfile', response);
  }

  @Action
  async fetchUserPermissions(payload: { company: string; project: string }) {
    const user = store.get('user');
    if (!user || !user.id || !user.jwt_token) {
      console.warn('[fetchUserPermissions] User not found or missing required fields');
      vuex.commit('User/setPermissionsAllowed', false);
      return;
    }

    try {
      const response = await API.post(
        '',
        `companies/${payload.company}/users/${user.id}/permissions/`,
        {
          project: payload.project
        }
      );

      if (response && response.roles) {
        vuex.commit('User/setUserRoles', response.roles);
        // console.log('[fetchUserPermissions] roles_in_scope:', response.roles);

        // Check if user has roles outside allowed list - show dialog and block access
        if (!isAnyAllowedRoles(response.roles)) {
          vuex.commit('Global/setForbiddenRolesDialog', true);
          vuex.commit('User/setPermissionsAllowed', false);
          return;
        }
      }
      vuex.commit('User/setPermissionsAllowed', true);
      return;
    } catch (error) {
      console.error('[fetchUserPermissions] Error fetching user permissions:', error);
    }
    vuex.commit('User/setPermissionsAllowed', false);
    return;
  }

  @Action
  projectDataUpdateEveryMinute() {
    const user = store.get('user') || null;
    if (!user || !user.company) return;

    // if (this.firstnotificationTime){
    //   vuex.dispatch('User/getProjectNotifications');
    // }
    vuex.dispatch('Projects/getAlerts');
    vuex.dispatch('Projects/getEvents');
  }

  @Action
  async updateUserProperty(prop_data) {
    const state = (vuex.state as any);
    try {
      await API.post(Types.PROPS, '',
        prop_data.value,
        { query: { name: prop_data.name, user: state.User.user_id } }
      );
      vuex.dispatch('User/fetchUserProperties');
    } catch (e) { }
  }

  @Mutation
  setUserProperties(properties) {
    this.properties = properties;
  }

  @Mutation
  setUserProfile(profile) {
    this.user_profile = profile;
  }

  @Mutation
  setUserRoles(roles) {
    this.roles = roles;
    const user = store.get('user');
    if (user) {
      user.roles = roles;
      store.set('user', user);
    }
  }

  @Mutation
  setPermissionsAllowed(isAllowed) {
    this.permissions_allowed = isAllowed;
  }

  // @Action async setUserNotificationTime() {
  //   if (localStorage.getItem('user')) {
  //     await API.get(Types.PROPS, '').then(async (res) => {
  //       if (res && res.results) {
  //         const prop = res.results.find(
  //           (p) => p.name === 'dashboard.notifications'
  //         );
  //         if (
  //           prop &&
  //           prop.value &&
  //           prop.value.hasOwnProperty('last_notification_seen')
  //         ) {
  //           vuex.commit(
  //             'User/setLastNotificationTime',
  //             prop.value.last_notification_seen
  //           );
  //         } else {
  //           await setUserProperty('dashboard.notifications', {
  //             last_notification_seen: 0
  //           });
  //           vuex.commit('User/setLastNotificationTime', 0);
  //         }
  //       } else {
  //         await setUserProperty('dashboard.notifications', {
  //           last_notification_seen: 0
  //         });
  //         vuex.commit('User/setLastNotificationTime', 0);
  //       }
  //     });
  //   }
  // }

  // @Action async getProjectNotifications() {
  //   let time = vuex.state['User'].firstnotificationTime;
  //   const project = store.get('project');
  //   if (time === 0) {
  //     await API.get(Types.PROPS, '')
  //       .then(async (props) => {
  //         if (props && props.results) {
  //           const prop = props.results.find(
  //             (p) => p.name === 'dashboard.notifications'
  //           );
  //           if (prop) {
  //             time = prop.value.last_notification_seen;
  //             vuex.commit(
  //               'User/setLastNotificationTime',
  //               prop.value.last_notification_seen
  //             );
  //           } else {
  //             await setUserProperty('dashboard.notifications', {
  //               last_notification_seen: 0
  //             });
  //             vuex.commit('User/setLastNotificationTime', 0);
  //           }
  //         } else {
  //           await setUserProperty('dashboard.notifications', {
  //             last_notification_seen: 0
  //           });
  //           vuex.commit('User/setLastNotificationTime', 0);
  //         }
  //       })
  //       .then(() => {
  //         if (
  //           project &&
  //           project.hasOwnProperty('notificationStreamId') &&
  //           project.notificationStreamId !== ''
  //         ) {
  //           API.get(
  //             Types.COMPANIES,
  //             `${project.company}/projects/${project.id}/streams/${
  //               project.notificationStreamId
  //             }/history/?from=${
  //               time && time !== 0 ? time : new Date().getTime() - 86400000
  //             }`
  //           ).then((res) => {
  //             const notifications = [];
  //             for (const notification of res) {
  //               notifications.push({
  //                 message: JSON.parse(notification[1]).value,
  //                 time: notification[0]
  //               });
  //             }
  //             vuex.commit(
  //               'User/setNotifications',
  //               notifications.filter((n) => n.time > time)
  //             );
  //           });
  //         }
  //       });
  //   } else if (time) {
  //     if (
  //       project &&
  //       project.hasOwnProperty('notificationStreamId') &&
  //       project.notificationStreamId !== ''
  //     ) {
  //       API.get(
  //         Types.COMPANIES,
  //         `${project.company}/projects/${project.id}/streams/${
  //           project.notificationStreamId
  //         }/history/?from=${
  //           time && time !== 0 ? time : new Date().getTime() - 86400000
  //         }`
  //       ).then((res) => {
  //         const notifications = [];
  //         for (const notification of res) {
  //           notifications.push({
  //             message: JSON.parse(notification[1]).value,
  //             time: notification[0]
  //           });
  //         }
  //         vuex.commit(
  //           'User/setNotifications',
  //           notifications.filter((n) => n.time > time)
  //         );
  //       });
  //     }
  //   }
  // }

  @Mutation
  setError(msg) {
    this.error = msg;
  }

  @Mutation
  setIsLoading(loading) {
    this.isLoading = loading;
  }

  @Mutation
  setManager(isManager) {
    this.isManager = isManager;
  }

  @Mutation
  setIntervalActive(is_active) {
    this.idleIntervalActive = is_active;
  }

  @Mutation
  updateDataEveryMinute() {
    vuex.commit('User/generalDataUpdateEveryMinute');
    vuex.dispatch('User/projectDataUpdateEveryMinute');
  }

  @Mutation
  setLogoutInterval() {
    if (this.idleInterval) {
      clearInterval(this.idleInterval);
      this.idleInterval = null;
    }

    if (!this.idleIntervalActive) {
      vuex.commit('User/setIntervalActive', true);
      this.idleInterval = setInterval(() => {
        if (!this.idleIntervalActive) {
          if (this.idleInterval) {
            clearInterval(this.idleInterval);
            this.idleInterval = null;
          }
          return;
        } else if (Utils.getIdleTimeInMinutes() >= 90) {
          vuex.commit('User/setIntervalActive', false);
          vuex.dispatch('User/logout');
          if (this.idleInterval) {
            clearInterval(this.idleInterval);
            this.idleInterval = null;
          }
          return;
        }
        vuex.commit('User/updateDataEveryMinute', moment().utcOffset(0).valueOf());
      }, 60000); // run every minute
    }
  }

  @Mutation
  generalDataUpdateEveryMinute() {
    const now = moment().utcOffset(0).valueOf();
    localStorage.setItem('now', now.toString());
    const day_of_week = Utils.getUTCDayOfWeek();
    if ((vuex.state as any).Global.day_of_week !== day_of_week) {
      vuex.commit('Global/setDayOfWeek', day_of_week);
    }
  }

  @Mutation
  listenToEvents() {
    window.addEventListener('load', Vue.prototype.$handler, true);
    const events = ['mousemove', 'keydown', 'scroll', 'touchstart'];
    events.forEach((name) => {
      document.addEventListener(name, Vue.prototype.$handler, true);
    });
  }

  @Mutation
  removeListeners() {
    window.removeEventListener('load', Vue.prototype.$handler, true);
    const events = ['mousemove', 'keydown', 'scroll', 'touchstart'];
    events.forEach((name) => {
      document.removeEventListener(name, Vue.prototype.$handler, true);
    });
  }

  @Mutation
  setUserData(data) {
    if (!data) return;
    const prev_data = store.get('user') || {};
    const user_data = { ...prev_data, ...data };

    if (user_data.allowed_companies && Object.keys(user_data.allowed_companies).length === 1) {
      user_data.company = Object.keys(user_data.allowed_companies)[0];
    }

    store.set('user', user_data);

    this.username = data.username;
    this.verified = data.verified;
    this.role = data.role;
    this.isAuth = true;
    this.user_id = data.id.toString();
    // setUserRoles persists the Cerbos roles of the selected project onto the stored user,
    // but on a page refresh only selectProject/fetchUserPermissions re-commit them - and
    // neither runs when the project is restored from localStorage. Without this, `roles`
    // stays empty after every refresh and role-gated features silently disappear.
    this.roles = user_data.roles || [];
  }

  @Mutation
  clearProject() {
    vuex.commit('MapSettings/setDeviceRepositioning', false);
    vuex.commit('Groups/flush');
    vuex.commit('Props/flush');
    vuex.commit('Reports/clearReports');
    vuex.commit('Reports/clearDevicesCount');
    vuex.commit('Reports/clearCabinetsCount');
    vuex.commit('User/unsetProject');
    vuex.commit('Global/setTimezone', null);
    this.mqtt.disconnect();
  }

  @Mutation
  clearProjects() {
    vuex.commit('Projects/flush');
    vuex.commit('Projects/clearProjectsData');
    vuex.commit('Global/setMqttVersions', new Map());
  }

  @Mutation
  clearUser() {
    store.remove('user');
    this.username = '';
    this.user_id = '';
    this.isAuth = false;
    this.isManager = false;
  }

  @Mutation
  clearCompanyData() {
    vuex.commit('User/clearProject');
    vuex.commit('User/clearProjects');
  }

  @Action
  async logout() {
    // Notify the server to invalidate the session. Fired before clearUser so
    // the JWT is still in storage for the Authorization header. Non-blocking:
    // local logout must proceed even if the request fails.
    API.get('', 'login/logout').catch((e) => console.log('logout request failed', e));

    vuex.commit('User/clearCompanyData');
    vuex.commit('User/clearUser');
    vuex.commit('Companies/setCompaniesList', {});
    vuex.commit('User/setIntervalActive', false);

    // Stop version checking when user logs out
    VersionService.stopPeriodicCheck();

    if (this.idleInterval) {
      clearInterval(this.idleInterval);
      this.idleInterval = null;
    }

    vuex.commit('User/removeListeners');
    vuex.commit('User/setUserProperties', []);
    vuex.commit('Global/setIsSidebarOpen', true);
    vuex.commit('User/setUserProfile', null);
    vuex.commit('Projects/clearProjectsState');

    if (localStorage.getItem('filtered_alerts_url')) {
      localStorage.removeItem('filtered_alerts_url');
    }
    router.push('/sign');
  }

  @Action
  async selectProject(data = store.get('project')) {
    if (!data || !data.id) {
      // console.log('[User.selectProject] No data or id, returning');
      return;
    }
    // console.log('[User.selectProject] Selecting project', data);
    // Set user permissions from stored project data for XX role users
    const user = store.get('user');
    if (user && user.role === 'XX' && data.id !== 'allProjects') {
      // Use stored roles from project data instead of fetching
      if (data.roles) {
        vuex.commit('User/setUserRoles', data.roles);
        // Check if roles are allowed using imported function
        const permissionsAllowed = isAnyAllowedRoles(data.roles);
        vuex.commit('User/setPermissionsAllowed', permissionsAllowed);
        // console.log('[User.selectProject] Using stored permissions', data.roles, permissionsAllowed);
        if (!permissionsAllowed) {
          return;
        }
      } else {
        // Fallback to fetching if not stored (shouldn't happen with new logic)
        vuex.commit('User/setPermissionsAllowed', null);
        await vuex.dispatch('User/fetchUserPermissions', {
          company: data.company,
          project: data.id
        });
        const permissionsAllowed = (vuex.state as any).User.permissions_allowed;
        if (permissionsAllowed === false) {
          return;
        }
      }
    }

    vuex.commit('User/setSelectedProject', data);

    // Load project metadata
    if (data.id !== 'allProjects') {
      // Load metadata for single project
      vuex.dispatch('Projects/loadSelectedProjectMetadata', {
        company_id: data.company,
        project_id: data.id
      });
    } else {
      // Load metadata for all projects that don't have it yet
      vuex.dispatch('Projects/loadAllProjectsMetadata', data.projects);
    }
  }

  @Mutation
  setSelectedProject(data) {
    store.set('project', data);
    this.project = data;
  }

  @Mutation
  selectCabinet(data) {
    this.cabinet = data;
  }

  @Mutation
  unsetProject() {
    store.remove('project');
    this.project = null;
  }

  // @Mutation
  // setLastNotificationTime(time) {
  //   this.firstnotificationTime = time;
  // }

  // @Mutation
  // setNotifications(data) {
  //   this.notifications = data.filter(
  //     (notification) => notification.time > this.firstnotificationTime
  //   );
  // }

  // @Mutation
  // closeNotification(time) {
  //   this.firstnotificationTime = time + 1;
  //   this.notifications.splice(0, 1);
  //   setUserProperty('dashboard.notifications', {
  //     last_notification_seen: time + 1
  //   });
  // }
}
